import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { UsersService } from '../user-management/users/users.service';

@Injectable()
export class ReportsPermissionGuard implements CanActivate {
  constructor(private usersService: UsersService, private router: Router) {}

  public canActivate(): Observable<boolean> {
    this.usersService.getUser();
    return this.usersService.allowReports().pipe(
      tap((isAllowed: boolean) => {
        if (!isAllowed) {
          this.router.navigate(['support']);
        }
        return isAllowed;
      })
    );
  }
}
